// Re-export the component and related helpers from the dedicated subdirectory
export { DeesInputWysiwyg } from './dees-input-wysiwyg/dees-input-wysiwyg.js';
export * from './dees-input-wysiwyg/index.js';
